var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcqType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.875 21.85H20.125C20.9189 21.85 21.5625 21.3351 21.5625 20.7V2.3C21.5625 1.66487 20.9189 1.15 20.125 1.15H2.875C2.08109 1.15 1.4375 1.66487 1.4375 2.3V20.7C1.4375 21.3351 2.08109 21.85 2.875 21.85ZM20.125 23H2.875C1.28718 23 0 21.9702 0 20.7V2.3C0 1.02974 1.28718 0 2.875 0H20.125C21.7128 0 23 1.02974 23 2.3V20.7C23 21.9702 21.7128 23 20.125 23Z",
    fill: "#001B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0117 6.0887C10.0117 5.71502 10.2978 5.41211 10.6507 5.41211H18.3187C18.6717 5.41211 18.9577 5.71502 18.9577 6.0887C18.9577 6.46238 18.6717 6.76529 18.3187 6.76529H10.6507C10.2978 6.76529 10.0117 6.46238 10.0117 6.0887Z",
    fill: "#001B4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0117 8.79573C10.0117 8.42205 10.2978 8.11914 10.6507 8.11914H18.3187C18.6717 8.11914 18.9577 8.42205 18.9577 8.79573C18.9577 9.16941 18.6717 9.47232 18.3187 9.47232H10.6507C10.2978 9.47232 10.0117 9.16941 10.0117 8.79573Z",
    fill: "#001B4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0117 14.2078C10.0117 13.8342 10.2978 13.5312 10.6507 13.5312H18.3187C18.6717 13.5312 18.9577 13.8342 18.9577 14.2078C18.9577 14.5815 18.6717 14.8844 18.3187 14.8844H10.6507C10.2978 14.8844 10.0117 14.5815 10.0117 14.2078Z",
    fill: "#001B4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0117 16.9119C10.0117 16.5383 10.2978 16.2354 10.6507 16.2354H18.3187C18.6717 16.2354 18.9577 16.5383 18.9577 16.9119C18.9577 17.2856 18.6717 17.5885 18.3187 17.5885H10.6507C10.2978 17.5885 10.0117 17.2856 10.0117 16.9119Z",
    fill: "#001B4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8991 14.8844V16.9142H6.8161V14.8844H4.8991ZM4.2601 13.5312H7.4551C7.80803 13.5312 8.09411 13.8342 8.09411 14.2078V17.5908C8.09411 17.9645 7.80803 18.2674 7.4551 18.2674H4.2601C3.90719 18.2674 3.62109 17.9645 3.62109 17.5908V14.2078C3.62109 13.8342 3.90719 13.5312 4.2601 13.5312Z",
    fill: "#001B4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54594 5.61027C8.79547 5.87447 8.79547 6.30289 8.54594 6.5671L5.5381 9.75188L3.80825 7.92028C3.55871 7.65607 3.55871 7.22765 3.80825 6.96345C4.0578 6.69924 4.46239 6.69924 4.71194 6.96345L5.5381 7.83821L7.64227 5.61027C7.8918 5.34606 8.29641 5.34606 8.54594 5.61027Z",
    fill: "#001B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcqType);
export default __webpack_public_path__ + "static/media/mcq-type.1a59efe2035313f8fa97e559c847461e.svg";
export { ForwardRef as ReactComponent };